import mongoose from "mongoose";
import { z } from "zod";

const isValidId = (id) => mongoose.Types.ObjectId.isValid(id);

export const MovieGalleryValidationSchema = z.object({
  title: z
    .string()
    .transform((val) => val.trim())
    .optional(),

  description: z
    .string()
    .transform((val) => val.trim())
    .optional(),

  thumbnail: z.string().refine((value) => isValidId(value), {
    message: "Thumbnail must be a valid ObjectId.",
  }),

  video_url: z.string().refine((value) => isValidId(value), {
    message: "Video must be a valid ObjectId.",
  }),
  
  order_number: z
    .string()
    .transform((val) => val.trim() || "1")
    .refine((val) => !isNaN(Number(val)) && Number.isInteger(Number(val)), {
      message: "Order number must be a valid number",
    })
    .refine((val) => Number(val) > 0, {
      message: "Order number must be greater than 0",
    }),
});
